<template>
  <PopUpOverlay
    @closeOverlay="setDialogNewProjectShow(false), new_project_name = ''"
    width="600px">
    <template #head>
      <TText
        value="create_new_project"
        font_weight="400"
        medium
      />
    </template>
    <template #body>
      <DisableableInputField
        label="Projectname"
        :is_disabled="false"
        :value="new_project_name"
        background_color="color-1"
        @change="new_project_name = $event"
        />
      <div class="d-flex align-center pt-2">
        <RadialCheckbox
        foreground_color="white"
        shadow="black"
        @click.native.prevent.stop="is_checked = !is_checked"
        :is_checked="is_checked"
        />
        <TText
        class="pl-2"
        value="Add_to_Company"
        font_weight="400"
        medium
        />
      </div>
    </template>
    <template #additional_v-btn_right>
        <v-btn
          color="green lighten-1"
          text="text"
          @click="createUObject({
              url: [
                {projects: ''},
                {'showWithEntitiesNormalized': ''}
              ],
              u_object: {
                name: new_project_name,
                add_to_business: is_checked
              }
            }).then((id) => {
              joinProject(id);
              enterEditMode({project_id: id});
              $router.push({
                name: 'AddTrain',
                params: {
                  project_id: id,
                  train_index: 0,
                  direction: 0
                }
              });
              setDialogNewProjectShow(false), new_project_name = ''
            })">
            <TText value="Create_Project" color="green" font_weight="400"/>
        </v-btn>
        <v-btn
          color="green lighten-1"
          text="text"
          @click="createUObject({
              url: [
                {multiprojects: ''},
                {'showWithEntitiesNormalized': ''}
              ],
              u_object: {
                name: new_project_name
              }
            }).then((id) => {
              setDialogNewProjectShow(false), new_project_name = ''
            })">
            <TText value="Create_Multiproject" color="green" font_weight="400"/>
        </v-btn>
    </template>
  </PopUpOverlay>
</template>
<script>
// import LoadingButton from '@/components/UserFeedback/LoadingButton.component.vue'
import RadialCheckbox from '@/components/WorkPackageWIP/RadialCheckbox.component.vue';
import TText from '@/components/Taktify/TText.component.vue'
import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue'
import PopUpOverlay from '@/components/WorkPackageWIP/PopUpOverlay.component.vue'
import {
  mapGetters,
  mapActions
} from 'vuex';
export default {
  components: {
    PopUpOverlay,
    DisableableInputField,
    TText,
    RadialCheckbox
    // LoadingButton
  },
  props: [],
  data: () => ({
    new_project_name: '',
    is_checked: false
  }),
  computed: {
    ...mapGetters('View', [
      'get_dialog_new_project_show'
    ]),
    ...mapGetters('Project', [
      'isLoading'
    ]),
  },
  methods: {
    ...mapActions('View', [
      'setDialogNewProjectShow'
    ]),
    ...mapActions('Project', [
      'enterEditMode'
    ]),
    ...mapActions('Ultra', [
      'createUObject'
    ]),
    ...mapActions('Auth', [
      'joinProject'
    ]),
    createMultiProject() {
    },
    createSingleProject() {
    }
  }
};
</script>
